import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import { UserContext } from "context/user";
import CustomModal from "components/Modal";
import SelectCountry from "components/block/SelectCountry";
import Button from "components/Button";
import "./index.scss";
import { updateContactDetails, createContactDetails } from "api/User";

const CountryModal = ({ contactDetails }) => {
  const { token, user } = useContext(UserContext);
  const [selectedCountry, setSelectedCountry] = useState("");

  const handleSubmitCountry = async () => {
    if (contactDetails) {
      const params = {
        data: {
          ...contactDetails,
          country: selectedCountry.toLocaleLowerCase(),
        },
      };

      const response = await updateContactDetails(params, token);

      if (response.status === 204) {
        window.location.reload();
      }
    } else {
      const params = {
        data: {
          first_name: "",
          last_name: "",
          phone_number: "",
          email: user.email,
          address1: "",
          city: "",
          state: "",
          post_code: "",
          country: selectedCountry.toLocaleLowerCase(),
        },
      };

      const response = await createContactDetails(params, token);

      if (response.status === 201) {
        window.location.reload();
      }
    }
  };

  return (
    <CustomModal isOpen onClose={() => {}} onRequestClose={() => {}} blurred>
      <div className="payment-update-country">
        <h2>Country required</h2>
        <div className="description">
          Your country is required in order for us to give you an exact price
          for your purchase.
        </div>
        <SelectCountry
          label="Country"
          value={selectedCountry}
          onChange={(value) => setSelectedCountry(value)}
          errorMessage="Please select a country"
        />
        <Button
          block
          color="green"
          label="Save as my country"
          disabled={!selectedCountry}
          onClick={() => handleSubmitCountry()}
        />
      </div>
    </CustomModal>
  );
};

CountryModal.defaultProps = {
  contactDetails: null,
};

CountryModal.propTypes = {
  contactDetails: PropTypes.object,
};

export default CountryModal;
